mutation DuplicateProduct(
    $selector: ProductSelectorInput!
    $naturalKey: String!
    $suffix: Boolean
) {
    duplicateProduct(
        selector: $selector
        naturalKey: $naturalKey
        suffix: $suffix
    ) {
        errors {
            message
        }
        product {
            id
            revisionID
        }
    }
}
